<template>
  <div class="baseInfoBox">
    <div class="nyp-ai-box">
      <div class="line-box y-p-r">
        <div class="tit-desp">选择商品<span class="y-fc-F0484A">*</span></div>
        <div class="y-mb-24">
          <div v-if="!tableData.length" class="add-pro-style" @click="addProductFn">
            <span class="add">+</span>
            <div class="add-txt">添加商品</div>
          </div>
          <div v-else class="pro-img-style y-p-r y-f y-f-a">
            <div class="img" @mouseenter.prevent.stop="isMousehover=true" @mouseleave.prevent.stop="isMousehover=false">
              <el-image
                scrollContainer=".yto-x-auto"
                lazy
                v-if="tableData[0].imageUrl || tableData[0].productPic"
                style="width: 78px;height: 78px;"
                :src="tableData[0].imageUrl || tableData[0].productPic"
                :preview-src-list="[tableData[0].imageUrl || tableData[0].productPic]">
              </el-image>
              <div class="y-p-a edit-box y-f y-f-a y-f-jc" v-if="isMousehover && !disabledChange" @click="addProductFn">
                <div class="edit-img">编辑</div>
              </div>
            </div>
            <div class="proTxt">
              <div>商品名称：{{ tableData[0].productName }}</div>
              <div>商品简称：{{ tableData[0].productShortName }}</div>
              <div>商品编码：{{ tableData[0].productCode }}</div>
            </div>
          </div>
        </div>
        <el-form :model="form" ref="ruleForm" :rules="rules" label-width="0">
          <div class="tit-desp">文案长度<span class="y-fc-F0484A">*</span></div>
          <el-form-item label="" prop="lengthCode" class="y-mb-24">
            <el-select v-model="form.lengthCode" placeholder="请选择" class="y-w-320">
              <template v-if="productDescType==1 || productDescType==4 || productDescType==111">
                <el-option v-for="item in xhsLengthList" :key="item.id" :label="item.name" :value="item.code"></el-option>
              </template>
              <template v-if="productDescType==2||productDescType==222">
                <el-option v-for="item in lengthList" :key="item.id" :label="item.name" :value="item.code"></el-option>
              </template>
              <template v-if="productDescType==3">
                <el-option v-for="item in titleLengthList" :key="item.id" :label="item.name" :value="item.code"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <div class="tit-desp">参考文案</div>
          <el-form-item label="" prop="referenceKey" class="y-mb-24">
            <el-input maxlength="200" type="textarea" show-word-limit v-model="form.referenceKey" placeholder="请将需要参考的文案粘贴到此处" :rows="8"></el-input>
          </el-form-item>
          <div class="tit-desp">其他要求</div>
          <el-form-item label="" prop="otherKey" class="y-mb-24">
            <el-input maxlength="200" type="textarea" show-word-limit v-model="form.otherKey" placeholder="如：“语气可爱一点”" :rows="8"></el-input>
            <div class="y-mt-8">
              <span v-for="(item, ind) in form.otherKeyTipList" :key="ind" class="form-tip" :class="{'active': form.otherKey&&form.otherKey.indexOf(item)>-1}" @click="fillOtherKeyFn(item)">{{item}}</span>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="bottombox y-f y-f-a y-f-je">
      <div class="clearBtn" @click="handleClose"><i class="el-icon-delete y-mr-5"></i>清空</div>
      <div class="confirmBtn" @click="reCreateFn" :class="{'disableStyle': !tableData.length||!form.lengthCode}" v-text="getBtnTxt()"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'base-info',
  props: ['form','productDescType', 'newCreate', 'aiLoading'],
  data() {
    return {
      // form: {
      //   lengthCode: '',
      //   referenceKey: '',
      //   otherKey: '',
      //   otherKeyTipList: []
      // },
      rules: {
        lengthCode: [
          { required: true, message: '请选择文案长度', trigger: 'blur' }
        ]
      },
      lengthList: [
        {name: '较短(50字以内)', code: '50'},
        {name: '适中(200字以内)', code: '200'},
        {name: '较长(500字以内)', code: '500'},
      ],
      titleLengthList: [
        {name: '较短(10字以内)', code: '10'},
        {name: '适中(20字以内)', code: '20'},
        {name: '较长(30字以内)', code: '30'},
      ],
      xhsLengthList: [
        {name: '较短(100字以内)', code: '100'},
        {name: '适中(300字以内)', code: '300'},
        {name: '较长(1000字以内)', code: '1000'},
      ],
      tableData: [],
      isShowDialog: false,
      isMousehover: false,
      disabledChange: false,
      isDisabled: false
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    },
  },
  watch: {
    aiLoading(val) {
      this.isDisabled = val || false;
    }
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      // this.form = this.formdata;
      this.setFormLenCodeFn();
    },
    fillOtherKeyFn(item) {
      let otherKey = this.form.otherKey.trim();
      let list = [];
      if (otherKey) {
        list.push(otherKey)
      }
      list.push(item);
      this.form.otherKey = list.join('；');
    },
    setFormLenCodeFn() {
      let val = this.productDescType;
      let lenCode = '200';
      let tipList = [];
      switch (val) {
        case 1:
        case 111:
          lenCode = '300';
          tipList = ['突出性价比', '语气可爱一点', '文艺一点儿'];
          break;
        case 2:
          lenCode = '200';
          tipList = ['突出性价比', '语气可爱一点', '文艺一点儿'];
          break;
        case 3:
          lenCode = '20';
          tipList = ['突出性价比', '满300-30'];
          break;
        case 4:
          lenCode = '300';
          tipList = ['突出性价比', '语气可爱一点', '文艺一点儿'];
          break;
        case 222:
          lenCode = '200';
          tipList = ['语气可爱一点', '语气幽默一点',  '语气诚恳一点'];
          break;
        default:
          str = '';
          tipList = [];
      }
      this.form.lengthCode = lenCode;
      this.form.otherKeyTipList = tipList;
    },
    addProductFn() {
      if (this.isDisabled) {
        this.$message.error('智多星正在生成，请稍等');
        return false;
      }
      this.$emit('addProduct', this.tableData || []);
    },
    reCreateFn() {
      if (this.isDisabled) {
        this.$message.error('智多星正在生成，请稍等');
        return false;
      }
      // 没有选商品或选文案长度，不能生成文案
      if (!this.tableData.length||!this.form.lengthCode) {
        return false;
      }
      this.$emit('aiCreate', '');
    },
    handleClose() {
      // this.form = {
      //   lengthCode: '',
      //   referenceKey: '',
      //   otherKey: '',
      //   otherKeyTipList: []
      // },
      this.setFormLenCodeFn();
      this.tableData = [];
      this.$emit('clear');
    },
    getBtnTxt() {
      if (this.productDescType == 111) {
        return '生成卖点';
      } else if (this.productDescType == 222) {
        return '生成评价分析';
      } else {
        return '生成文案';
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss" scoped>
@import "../../../styles/variables";
.baseInfoBox {
  height: calc(100vh - 100px);
  min-height: 819px;
  position: relative;
}
.add-pro-style {
  width: 78px;
  height: 78px;
  background: #F7F8FA;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  color: #666666;
  .add {
    display: inline-block;
    font-size: 40px;
  }
  .add-txt {
    font-weight: 400;
    font-size: 14px;
    color: #515151;
    line-height: 20px;
  }
}
.pro-img-style {
  width: 78px;
  height: 78px;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  .edit-box {
    top: 0;
    left: 0;
    width: 78px;
    height: 78px;
    background: rgba($color: #000000, $alpha: 0.3);
  }
  .edit-img {
    color: #fff;
  }
  .proTxt {
    width: 260px;
    flex-shrink: 0;
    margin-left: 8px;
    font-weight: 400;
    font-size: 14px;
    color: #2F2D2D;
    line-height: 20px;
    text-align: left;
  }
}
.tit-desp {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  margin-bottom: 10px;
}
.form-tip {
  height: 24px;
  line-height: 24px;
  background: #F5F5F5;
  border-radius: 4px;
  border: 1px solid #E9E9E9;  
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  padding: 4px 16px;
  margin-right: 8px;
}
.form-tip.active {
  background: $tiffany;
  border: 1px solid $blue-style;
  color: $blue-style;
}
.y-mb-24 {
  margin-bottom: 24px;
}
.y-mt-8 {
  margin-top: 8px;
}
.bottombox {
  position: absolute;
  width: calc(100% - 48px);
  padding: 14px 24px;
  bottom: 0;
  left: 0;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
  border-radius: 16px;
  .clearBtn {
    width: 137px;
    height: 36px;
    line-height: 36px;
    font-weight: 400;
    font-size: 14px;
    color: #1F1F1F;
    text-align: center;
    cursor: pointer;
  }
  .confirmBtn {
    width: 137px;
    height: 36px;
    line-height: 36px;
    background: #653EB3;
    border-radius: 8px;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    text-align: center;
    cursor: pointer;
  }
  .confirmBtn.disableStyle {
    opacity: 0.5;
  }
}
</style>
